import { render, staticRenderFns } from "./WholesaleBillDeleted.vue?vue&type=template&id=92f0d904&scoped=true"
import script from "./WholesaleBillDeleted.vue?vue&type=script&lang=js"
export * from "./WholesaleBillDeleted.vue?vue&type=script&lang=js"
import style0 from "./WholesaleBillDeleted.vue?vue&type=style&index=0&id=92f0d904&prod&scoped=true&lang=css"
import style1 from "./WholesaleBillDeleted.vue?vue&type=style&index=1&id=92f0d904&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f0d904",
  null
  
)

export default component.exports